import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

export function provideTranslocoScopeFactoryEditMachinePark(): Provider {
  return provideTranslocoScope({
    scope: 'shared-factory-edit-machine-park',
    alias: 'factoryEditMachinePark',
    loader: i18nLoader,
  });
}
